module.exports = __webpack_public_path__ + "img/EXTERIOR-SCROSS-4.a86bee69.jpg";